var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "modal__form",
      on: {
        submit: function($event) {
          $event.preventDefault()
        }
      }
    },
    [
      _c("header", { staticClass: "modal__header" }, [
        _c("h2", [_vm._v("Password recovery")]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "img",
            on: {
              click: function($event) {
                return _vm.$emit("close")
              }
            }
          },
          [
            _c("img", {
              attrs: { src: _vm.mediaBaseUrl + "close.svg", alt: "close" }
            })
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "fields" },
        _vm._l(_vm.formFields, function(field) {
          return _c(
            "label",
            { key: field.name, class: [{ field_error: field.error }] },
            [
              _c("span", [_vm._v(_vm._s(field.name))]),
              _vm._v(" "),
              field.type === "checkbox"
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: field.value,
                        expression: "field.value"
                      }
                    ],
                    attrs: { required: "", type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(field.value)
                        ? _vm._i(field.value, null) > -1
                        : field.value
                    },
                    on: {
                      change: function($event) {
                        var $$a = field.value,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(field, "value", $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                field,
                                "value",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(field, "value", $$c)
                        }
                      }
                    }
                  })
                : field.type === "radio"
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: field.value,
                        expression: "field.value"
                      }
                    ],
                    attrs: { required: "", type: "radio" },
                    domProps: { checked: _vm._q(field.value, null) },
                    on: {
                      change: function($event) {
                        return _vm.$set(field, "value", null)
                      }
                    }
                  })
                : _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: field.value,
                        expression: "field.value"
                      }
                    ],
                    attrs: { required: "", type: field.type },
                    domProps: { value: field.value },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(field, "value", $event.target.value)
                      }
                    }
                  }),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: field.error,
                      expression: "field.error"
                    }
                  ],
                  staticClass: "error"
                },
                [_vm._v(_vm._s(field.errorMessage))]
              )
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("custom-button", { on: { click: _vm.submitForm } }, [
        _vm._v("\n    Submit\n  ")
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }